'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _spauiUtils = require('@tencent/spaui-utils');

var _info = require('./info');

var _info2 = _interopRequireDefault(_info);

var _topnav_props = require('./topnav_props');

var _NavBarHeader = require('./component/NavBarHeader');

var _NavBarHeader2 = _interopRequireDefault(_NavBarHeader);

var _NavBarCollapse = require('./component/NavBarCollapse');

var _NavBarCollapse2 = _interopRequireDefault(_NavBarCollapse);

var _topnav_compact_props = require('./topnav_compact_props');

var _topnav_compact_props2 = _interopRequireDefault(_topnav_compact_props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Tencent is pleased to support the open source community by making SPA UI available.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Copyright (C) 2019, a Tencent company. All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */
/**
 * @fileOverview spaui-topnav kirkzheng
 * @author kirkzheng
 * @time Sun May 13 2018 13:31:23 GMT+0800 (中国标准时间)
 * @module spaui-topnav
 * @example
 * import TopNav from '@tencent/spaui-topnav';
 * import '@tencent/spaui-topnav/lib/index.css';
 *
 * &lt;TopNav {...this.props} /&gt;
 */

/**
 * @class
 */
var TopNav = function (_PureComponent) {
    _inherits(TopNav, _PureComponent);

    function TopNav(props) {
        _classCallCheck(this, TopNav);

        var _this = _possibleConstructorReturn(this, (TopNav.__proto__ || Object.getPrototypeOf(TopNav)).call(this, props));

        var _compactProps = (0, _topnav_compact_props2.default)(props),
            open = _compactProps.open;

        _this.state = {
            open: open
        };

        _this.handleOpen = _this.handleOpen.bind(_this);
        return _this;
    }

    _createClass(TopNav, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
                (0, _spauiUtils.checkCssVersion)(_info2.default);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // 如果指定了，那就一直以参数的为准
            if (typeof nextProps.isOpen !== 'undefined' || typeof nextProps.open !== 'undefined') {
                this.setState({
                    open: (0, _topnav_compact_props2.default)(nextProps)
                });
            }
        }
    }, {
        key: 'handleOpen',
        value: function handleOpen(event) {
            var _props = this.props,
                isOpen = _props.isOpen,
                open = _props.open;

            var _compactProps2 = (0, _topnav_compact_props2.default)(this.props),
                onOpen = _compactProps2.onOpen;

            var result = !this.state.open;

            // 如果没有自己设置，就默认组件内维护
            if (typeof isOpen === 'undefined' && typeof open === 'undefined') {
                this.setState({
                    open: result
                });
            }

            if ((0, _spauiUtils.isFunction)(onOpen)) {
                onOpen(event, result);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                title = _props2.title,
                rootUrl = _props2.rootUrl,
                logoUrl = _props2.logoUrl,
                logoAttribute = _props2.logoAttribute,
                headerProps = _props2.headerProps,
                collapseProps = _props2.collapseProps,
                list = _props2.list,
                searchValue = _props2.searchValue,
                onSearchChange = _props2.onSearchChange,
                LinkComponent = _props2.LinkComponent,
                propsLogoComponent = _props2.LogoComponent,
                propsLogoTitleComponent = _props2.LogoTitleComponent,
                _props2$titleEvent = _props2.titleEvent,
                titleEvent = _props2$titleEvent === undefined ? {} : _props2$titleEvent,
                _props2$logoEvent = _props2.logoEvent,
                logoEvent = _props2$logoEvent === undefined ? {} : _props2$logoEvent,
                _props2$value = _props2.value,
                value = _props2$value === undefined ? '' : _props2$value;
            var open = this.state.open;

            var LogoComponent = propsLogoComponent || LinkComponent;
            var LogoTitleComponent = propsLogoTitleComponent || LinkComponent;

            return _react2.default.createElement(
                'div',
                (0, _spauiUtils.globalProps)(this.props, {
                    className: 'spaui-topnav spaui-topnav-dark is-fixed-top',
                    needTitle: false
                }),
                _react2.default.createElement(_NavBarHeader2.default, _extends({
                    title: title,
                    rootUrl: rootUrl,
                    logoUrl: logoUrl,
                    logoAttribute: logoAttribute
                }, headerProps, {
                    open: open,
                    titleEvent: titleEvent,
                    logoEvent: logoEvent,
                    LinkComponent: LinkComponent,
                    LogoComponent: LogoComponent,
                    LogoTitleComponent: LogoTitleComponent,
                    onOpen: this.handleOpen
                })),
                _react2.default.createElement(_NavBarCollapse2.default, _extends({
                    searchValue: searchValue,
                    onSearchChange: onSearchChange,
                    list: list,
                    open: open,
                    value: value,
                    LinkComponent: LinkComponent
                }, collapseProps))
            );
        }
    }]);

    return TopNav;
}(_react.PureComponent);

// 组件标记


TopNav.propTypes = _topnav_props.propTypes;
TopNav.defaultProps = _topnav_props.defaultProps;
(0, _spauiUtils.setComponentMark)(TopNav, _info2.default);
// 组件上报
(0, _spauiUtils.reportComponentUsage)(_extends({
    scope: 'spaui'
}, _info2.default));

exports.default = TopNav;